import BaseGraphController from "./base_graph_controller";
export default class extends BaseGraphController {
  // Chart config.
  config(labels, data) {
    const config = {
      type: "bar",
      data: {
        labels: labels,
        datasets: data,
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              padding: 10,
              includeBounds: true,
            },
            grid: { display: false },
            border: { color: "transparent" }
          },
          y: {
            grid: {
              drawOnChartArea: true,
              drawTicks: false
            },
            ticks: { padding: 10 },
            border: { color: "transparent" }
          },
        },
      }
    };

    return config;
  }
}
